import React from "react";
import "./JumboEmbed.scss";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";

const SubUserEmbedErrorPage = () => {
    const { getTextByKey } = useContent();

    return (
        <div className="embed-sub-user-error-page">
            <Image name="inbox-empty" ext="png" alt="" title="" />
            <div className="title">
                {getTextByKey("sub-user-embed-error-page-title")}
            </div>
            <div className="text">
                {getTextByKey("sub-user-embed-error-page-text")}
            </div>
        </div>
    );
};
export default SubUserEmbedErrorPage;
